//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from 'vue-avatar'
import { removeJwt } from '~/utils/jwt';

export default {
  computed: {
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null
    },
    isOpen() {
      return this.$store.state.rightSidebarOpen
    }
  },
  components: {
    Avatar
  },
  watch: {
    isOpen: function (newVal, oldVal) {
      this.syncAutologinMethod();
    }
  },
  data() {
    return {
      //isOpen: true,
      autologinEnabled: false,
      hasBiometrics: false,
      biometricMethod: null,
      loginMethod: null,
      selectedTab: null,
      sports: []
    }
  },
  mounted() {
    this.syncAutologinMethod();
  },
  methods: {
    async goTo(section = null) {
      this.$store.commit('openRightSidebar', false)
      this.$router.push(this.localePath(section))
    },

    async syncAutologinMethod() {
      if(this.platform == 'web')
        return;

      let biometricMode = 'NONE';
      let types = ['NONE', 'TOUCH_ID', 'FACE_ID', 'FINGERPRINT', 'FACE_AUTHENTICATION', 'IRIS_AUTHENTICATION'];
      try {
        let result = await this.$CapacitorNativeBiometric.isAvailable()
        if(result.isAvailable) {
          console.log('biometryType', _.get(types, result.biometryType))
          biometricMode = _.get(types, result.biometryType)
          this.biometricMethod = _.get(types, result.biometryType)
          this.hasBiometrics = true
        } 
      } catch(e) {}

      const res = await this.$CapacitorStorage.get({ key: 'login_mode' });
      let login_mode = _.get(res, 'value')
      if (login_mode == 'auto') {
        this.loginMethod = 'AUTO'
      }
      if (login_mode == 'biometric' && this.hasBiometrics && biometricMode != 'NONE') {
        this.loginMethod = biometricMode
      }

      if (login_mode == 'auto' || login_mode == 'biometric') {
        this.autologinEnabled = true;
      } else {
        this.autologinEnabled = false;
      }
      
    },

    async toggleAutologin(mode = 'auto') {
      const res = await this.$CapacitorStorage.get({ key: 'login_mode' });
      let login_mode = _.get(res, 'value')
      
      let preffered_mode = 'auto';
      try {
        let result = await this.$CapacitorNativeBiometric.isAvailable()
        if(result.isAvailable && mode == 'biometric') {
          preffered_mode = 'biometric';
        }
      } catch(e) {

      }

      if (mode == 'auto') {
        if (login_mode == 'auto') {
          await this.$CapacitorStorage.set({ key: 'login_mode', value: null })
          this.$CapacitorToast.show({ text: this.$t('Disabled auto login')});
        } else {
          await this.$CapacitorStorage.set({ key: 'login_mode', value: mode })
          this.$CapacitorToast.show({ text: this.$t('Enabled auto login')});
        }
      }

      if (mode == 'biometric') {
        if (login_mode == 'biometric') {
          await this.$CapacitorStorage.set({ key: 'login_mode', value: null })
          this.$CapacitorToast.show({ text: this.$t('Disabled biometric login')});
        } else {
          await this.$CapacitorStorage.set({ key: 'login_mode', value: preffered_mode })
          this.$CapacitorToast.show({ text: this.$t('Enabled biometric login')});
        }
      }

      this.syncAutologinMethod();
    },

    // async openCashier(section = null) {
    //   this.$store.commit('openRightSidebar', false)
    //   if(this.platform == 'web') {
    //     this.loadGlobalIframe('open_page', { url: section })
    //   } else {
    //     let inAppBrowserRef = cordova.InAppBrowser.open(this.$config.GLOBAL_IFRAME + section+"?app="+this.operator_app, "_blank", "location=no,toolbar=yes,lefttoright=yes,presentationstyle=pagescreen,toolbarposition=top,disallowoverscroll=yes,hidenavigationbuttons=no,toolbartranslucent=no,closebuttoncaption=X,closebuttoncolor=#FFFFFF,enableViewportScale=no,footer=yes,fullscreen=no,hidenavigationbuttons=no,footercolor=#000000,closebuttoncaption=Close,toolbarcolor=#000000");
    //     inAppBrowserRef.addEventListener('loadstart', (e) => {
    //       console.log('loadstart', e);
    //     });
    //     inAppBrowserRef.addEventListener('message', (e) => {
	  //       console.log('inAppBrowserRef message', e);
    //     });
    //   }
    // },

    async logout() {
      try {
            let result = await this.$auth().post('/api/common/logout', {
                session_id: this.sessionToken,
            })
            window.zE("messenger", "logoutUser");
            console.log('result', result)
      } catch(e) {}
      
      this.$store.commit('auth/clearAuthentication')
      removeJwt(this.$nuxt)
      setTimeout(() => {
        //window.location.reload()
        //this.loadGlobalIframe('request_sport_token')
      }, 1000)
      this.$store.commit('openRightSidebar', false)
      await this.$router.push(this.localePath({path: '/'}))
    },
    open() {
      this.$store.commit('openRightSidebar', true)
    },
    close() {
      this.$store.commit('openRightSidebar', false)
    },
    goBack() {
      this.$router.back()
    }
  }
}
